import { STRINGS } from '@/strings/strings';

/**
 * Screen-2 state 6 — `anchor_attempt_stale` inline line.
 *
 * v3.1 §6 line 292 verbatim: "Toastzeile über der Fläche, Bild und
 * Knöpfe auf Deckkraft 40 %. Kein Rot, kein Kasten, kein Modal."
 *
 * Sebastian ruling 2026-08-05 §3: this is a plain inline element,
 * not a toast notification framework. The parent (`AnchorReviewScreen`)
 * renders this row above the surface and lowers the underlying
 * `StageView` + buttons to opacity 40% while the refetch is in flight.
 *
 * "Kein Rot" — this is not a customer error. `anchor_attempt_stale`
 * is a race the customer did not cause; the line explains it and the
 * envelope refetch resolves it. Text = `text-dream-navy/70`.
 */

export function AnchorStaleLine() {
  return (
    <p role="status" aria-live="polite" className="text-center text-sm text-dream-navy/70 py-3">
      {STRINGS.book.anchor.staleLine}
    </p>
  );
}
